import template from './template.html?raw'

class AutoComplete extends HTMLElement {

  connectedCallback() {

    // layout
    this.innerHTML = template

    // pass down attributes
    const inputEl = this.input
    const wrapper = this.firstElementChild
    const attrs = Object.assign({}, this.attributes)
    for(const prop in attrs){
      const attr = attrs[prop]
      const name = attr.name
      const value = attr.value
      // move options to wrapper x-data div, else goes on input
      const targetDiv = name == 'options' ? wrapper : inputEl
      targetDiv.setAttribute(name, value)
      this.removeAttribute(name)
    }
  }

  get input(){
    return this.querySelector('input')
  }
}

export default function () {
  customElements.define('auto-complete', AutoComplete)
}